var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebd42"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebd42"] = parcelRequire;
}

var $1gKYM = parcelRequire("1gKYM");

var $l8T0n = parcelRequire("l8T0n");
// VARIABLES
const $2997b813f71317f7$var$galleryImage = document.querySelector(".gallery__image");
const $2997b813f71317f7$var$galleryThumbnails = document.querySelector(".gallery__thumbnails");
const $2997b813f71317f7$var$galleryThumbnailContainers = document.querySelectorAll(".gallery__thumbnail-container");
const $2997b813f71317f7$var$lightbox = document.querySelector(".lightbox");
const $2997b813f71317f7$var$lightboxCloseBtn = document.querySelector(".lightbox__close-btn");
const $2997b813f71317f7$var$lightboxImagesContainer = document.querySelector(".lightbox__images");
const $2997b813f71317f7$var$lightboxImages = document.querySelectorAll(".lightbox__img");
const $2997b813f71317f7$var$previousBtn = document.querySelector(".lightbox__previous-btn");
const $2997b813f71317f7$var$nextBtn = document.querySelector(".lightbox__next-btn");
const $2997b813f71317f7$var$lightboxThumbnailContainers = document.querySelectorAll(".lightbox__thumbnail-container");
const $2997b813f71317f7$var$lightboxThumbnails = document.querySelector(".lightbox__thumbnails");
const $2997b813f71317f7$var$lightboxOverlay = document.querySelector(".lightbox__overlay");
// Initialize the current image index
let $2997b813f71317f7$var$currentImageIndex = 0;
// CODE FOR GALLERY
// FUNCTIONS
function $2997b813f71317f7$var$displayCorrectGalleryImg(target) {
    const thumbnailImage = target.querySelector(".gallery__thumbnail");
    $2997b813f71317f7$var$galleryImage.src = thumbnailImage.src;
}
// EVENT LISTENER CALLBACK FUNCTION
function $2997b813f71317f7$var$handleGalleryImageClick() {
    // This code solves the problem for when a gallery thumbnail is never clicked, the wrong lightbox image and thumbnail container might be displayed depending on how the user last interacted with the lightbox
    $2997b813f71317f7$var$displayCorrectLightboxImg($2997b813f71317f7$var$galleryThumbnailContainers);
    $2997b813f71317f7$var$makeThumbnailContainerClicked($2997b813f71317f7$var$currentImageIndex);
    // Display lightbox
    $2997b813f71317f7$var$lightbox.classList.add("lightbox--open");
}
// GALLERY EVENT LISTENER
$2997b813f71317f7$var$galleryImage.addEventListener("click", $2997b813f71317f7$var$handleGalleryImageClick);
// CODE FOR LIGHTBOX
// FUNCTIONS
function $2997b813f71317f7$var$displayCorrectLightboxImg(thumbnailContainers) {
    thumbnailContainers.forEach((container, index)=>{
        if (container.classList.contains("container-clicked")) {
            $2997b813f71317f7$var$currentImageIndex = index;
            if (thumbnailContainers === $2997b813f71317f7$var$lightboxThumbnailContainers) $2997b813f71317f7$var$lightboxImagesContainer.classList.add("transition");
            (0, $l8T0n.translateImage)($2997b813f71317f7$var$currentImageIndex, $2997b813f71317f7$var$lightboxImagesContainer);
        }
    });
}
function $2997b813f71317f7$var$makeThumbnailContainerClicked(currentImageIndex) {
    // Remove 'container-clicked' class from container that already has the class
    (0, $1gKYM.removeContainerClickedClass)($2997b813f71317f7$var$lightboxThumbnailContainers);
    // Add 'container-clicked' class to the container that has the same image as the lightbox image that is currently being displayed
    $2997b813f71317f7$var$lightboxThumbnailContainers[currentImageIndex].classList.add("container-clicked");
}
function $2997b813f71317f7$var$hideLightbox() {
    $2997b813f71317f7$var$lightboxImagesContainer.classList.remove("transition");
    $2997b813f71317f7$var$lightbox.classList.remove("lightbox--open");
}
// EVENT LISTENER CALLBACK FUNCTIONS
function $2997b813f71317f7$var$handleLightboxCloseBtnClick(e) {
    const lightboxCloseBtn = e.target.closest(".lightbox__close-btn");
    if (!lightboxCloseBtn) return;
    $2997b813f71317f7$var$hideLightbox();
}
function $2997b813f71317f7$var$handleLightboxOverlayClick(e) {
    const target = e.target;
    if (!target.classList.contains("lightbox__overlay")) return;
    $2997b813f71317f7$var$hideLightbox();
}
function $2997b813f71317f7$var$handleNavigationBtnClick(e) {
    const previousBtn = e.target.closest(".lightbox__previous-btn");
    const nextBtn = e.target.closest(".lightbox__next-btn");
    $2997b813f71317f7$var$currentImageIndex = (0, $l8T0n.updateImage)($2997b813f71317f7$var$lightboxImagesContainer, $2997b813f71317f7$var$lightboxImages, $2997b813f71317f7$var$currentImageIndex, previousBtn, nextBtn);
    $2997b813f71317f7$var$makeThumbnailContainerClicked($2997b813f71317f7$var$currentImageIndex);
}
// LIGHTBOX EVENT LISTENERS
$2997b813f71317f7$var$previousBtn.addEventListener("click", $2997b813f71317f7$var$handleNavigationBtnClick);
$2997b813f71317f7$var$nextBtn.addEventListener("click", $2997b813f71317f7$var$handleNavigationBtnClick);
$2997b813f71317f7$var$lightboxCloseBtn.addEventListener("click", $2997b813f71317f7$var$handleLightboxCloseBtnClick);
$2997b813f71317f7$var$lightboxOverlay.addEventListener("click", $2997b813f71317f7$var$handleLightboxOverlayClick);
// EVENT LISTENER CALLBACK FUNCTION FOR GALLERY AND LIGHTBOX THUMBNAILS
function $2997b813f71317f7$var$handleThumbnailClick(e, thumbnailContainerClass, thumbnailContainers) {
    // Check if event target is 'galleryThumbnails' or 'lightboxThumbnails'
    if (e.target === this) return;
    // Check if the event target or its parent has the class 'gallery__thumbnail-container' or 'lightbox__thumbnail-container'
    let target = e.target;
    while(target && target !== this){
        if (target.classList.contains(thumbnailContainerClass)) {
            // If container already has 'container-clicked' class, then do nothing
            if (target.classList.contains("container-clicked")) return;
            // Remove 'container-clicked' class from previously-clicked container
            (0, $1gKYM.removeContainerClickedClass)(thumbnailContainers);
            // Add 'container-clicked' class to the container that was just clicked
            target.classList.add("container-clicked");
            if (thumbnailContainers === $2997b813f71317f7$var$galleryThumbnailContainers) {
                // Change gallery image to the thumbnail image that was clicked
                $2997b813f71317f7$var$displayCorrectGalleryImg(target);
                // Make lightbox image the same image that was clicked in the gallery thumbnail container
                $2997b813f71317f7$var$displayCorrectLightboxImg($2997b813f71317f7$var$galleryThumbnailContainers);
                // Whichever image is currented displayed in the gallery, the lightbox thumbnail container with that image needs to have the 'container-clicked' class
                $2997b813f71317f7$var$makeThumbnailContainerClicked($2997b813f71317f7$var$currentImageIndex);
            }
            if (thumbnailContainers === $2997b813f71317f7$var$lightboxThumbnailContainers) // Whichever thumbnail container was clicked, the image inside that container needs to be displayed as the lightbox image.
            $2997b813f71317f7$var$displayCorrectLightboxImg($2997b813f71317f7$var$lightboxThumbnailContainers);
            return;
        }
        // Move up to the parent element
        target = target.parentElement;
    }
}
// GALLERY AND LIGHTBOX THUMBNAILS EVENT LISTENERS
$2997b813f71317f7$var$galleryThumbnails.addEventListener("click", (e)=>$2997b813f71317f7$var$handleThumbnailClick(e, "gallery__thumbnail-container", $2997b813f71317f7$var$galleryThumbnailContainers));
$2997b813f71317f7$var$lightboxThumbnails.addEventListener("click", (e)=>$2997b813f71317f7$var$handleThumbnailClick(e, "lightbox__thumbnail-container", $2997b813f71317f7$var$lightboxThumbnailContainers));


//# sourceMappingURL=index.d872ea81.js.map
